import styled from "styled-components";

export const BoldText = styled.span({
    fontWeight: "bold"
});
